// $FlowFixMe outdated flow types for the package
import React, { useState, useCallback } from 'react';
// $FlowFixMe outdated flow types for the package
import { useDispatch } from 'react-redux';
// $FlowFixMe outdated flow types for the package
import { useIntl } from 'react-intl';

import Dialog from '@/components/mui/Dialog';
import { bulkCreateApprovalsAction } from '@/domain/approvals/actions';
import StandAloneApprovalManager from '@/pages/common/Dialog/DialogManageBulkApprovalFlow/components/ApprovalsManager';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import useToggle from '@/hooks/useToggle';
import useApprovals from '@/hooks/approval/useApprovals';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { ContentArea } from '@/pages/common/Dialog/DialogManageBulkApprovalFlow/StyledComponents';
import Button from '@mui/material/Button';

const BulkApprovalFlow = ({ onClose, open, selectedIDs }) => {
  const [value, setValue] = useState([]);
  const [groupId, setGroupId] = useState('');
  const [advancedGroupId, setAdvancedGroupId] = useState('');
  const [approvalFlowAutoStart, toggleApprovalFlowAutoStart] = useToggle();
  const { approvers } = useApprovals();
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const submitApprovals = useCallback(
    () =>
      new Promise((resolve, reject) =>
        dispatch(
          bulkCreateApprovalsAction({
            value,
            selectedIDs,
            approvalFlowAutoStart,
            groupId,
            advancedGroupId,
            resolve,
            reject,
          }),
        ),
      )
        .then(() => onClose())
        .catch(() => onClose()),
    [onClose, dispatch, value, selectedIDs, approvalFlowAutoStart, groupId, advancedGroupId],
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={formatMessage({ id: 'documents.show.modals.approvals.title', defaultMessage: 'Add approvers' })}
      maxWidth="sm"
      withActions={false}
      withContent={false}
      withCloseBtn
      draggable={false}
    >
      <DialogContent>
        <ContentArea>
          <StandAloneApprovalManager
            setValue={setValue}
            approvers={approvers}
            currentValue={value}
            setGroupId={setGroupId}
            groupId={groupId}
            advancedGroupId={advancedGroupId}
            setAdvancedGroupId={setAdvancedGroupId}
          />
        </ContentArea>
      </DialogContent>
      <DialogActions sx={{ pl: 3 }}>
        <FormControlLabel
          checked={approvalFlowAutoStart}
          control={<Switch size="small" onChange={toggleApprovalFlowAutoStart} />}
          labelPlacement="end"
          sx={{ ml: 0 }}
          label={formatMessage({
            id: 'document.approval.form.bulkApprove.autoStart',
            defaultMessage: 'Start approval flow',
          })}
        />
        <div style={{ flex: '1 0 0' }} />
        <Button onClick={onClose}>
          {formatMessage({
            id: 'button.cancel',
            defaultMessage: 'Cencel',
          })}
        </Button>
        <Button onClick={submitApprovals} disabled={value.length === 0}>
          {formatMessage({
            id: 'button.create',
            defaultMessage: 'Create',
          })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BulkApprovalFlow;
